export default  {"src":"/_next/static/image/public/assets/icons/add-car.db7a4c35ab9d3a2de823a29ee1be465e.svg","height":127,"width":127};